import { render } from "./ComunicacionSMS.vue?vue&type=template&id=127fb5f0"
import script from "./ComunicacionSMS.vue?vue&type=script&lang=js"
export * from "./ComunicacionSMS.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__